"use client";

import type { CSSProperties, ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";

const buyBarShadow: CSSProperties = {
  boxShadow:
    "0 -4px 16px color-mix(in srgb, var(--c-forest-900) 8%, transparent)",
};

export function BuyActionBar({
  label,
  onClick,
  leftSlot,
  fixed = true,
  className,
  disabled = false,
  buttonType = "button",
}: {
  label: string;
  onClick?: () => void;
  leftSlot?: ReactNode;
  fixed?: boolean;
  className?: string;
  disabled?: boolean;
  buttonType?: "button" | "submit";
}) {
  return (
    <aside
      aria-label="购买操作"
      className={cn(
        "z-50 border-t border-line bg-card pb-[env(safe-area-inset-bottom)]",
        fixed
          ? "responsive-buy-bar fixed right-0 bottom-0 left-0 mx-auto w-full"
          : "relative w-full",
        className,
      )}
      style={buyBarShadow}
    >
      <div className="flex h-14 items-center gap-2 px-2.5">
        {leftSlot ?? <div className="w-11 shrink-0" aria-hidden="true" />}
        <Button
          variant="buy"
          className="min-w-0 flex-1 px-3"
          onClick={onClick}
          disabled={disabled}
          type={buttonType}
        >
          {label}
        </Button>
      </div>
    </aside>
  );
}
